<template>
    <div class="logo-container"
         @click="goHome">
        <div class="logo"></div>
    </div>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';
    import { navigationService } from '@/services/navigationService'

    export default defineComponent({
        props: {
            actionable: {
                type: Boolean,
                defaultValue: false
            }
        },
        data() {
            return {
            }
        },
        computed: {
        },
        methods: {
            goHome() {
                if (this.actionable) {
                    navigationService.goHomePage();
                }
            }
        }

    })

</script>

<style lang="scss">

    .logo-container {
        height: 45px;
        display: flex;
        align-items: center;
        cursor: pointer;
    }

    .logo {
        height: 100%;
        width: 165px;
        background-image: url('/src/images/loopword-logo.png');
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
    }

</style>